import { JSX, useEffect } from 'react';
import { useStore } from '@betgames/bg-state-manager';
import { feimSettingsStore } from '@bg-shared';
import classes from './FeimFreeze.module.scss';

export const FeimFreeze = (): JSX.Element => {
    const { freeze } = useStore(feimSettingsStore);

    useEffect(() => {
        document.body.classList.toggle(classes.body, freeze);
    }, [freeze]);

    if (!freeze) {
        return null;
    }

    return <div className={classes.container} data-qa="area-freeze-screen" />;
};
